const clear = `#pragma version 6
int 1`;

export default clear